module.exports = __webpack_public_path__ + "static/flag-poster-91ae3f4eab8b9368e0e6ddf14ad84334.jpg";